import { setClient } from '~/services/apiClient'

// 공통 API client 세팅 함수
export default ({ store, $axios, $method, redirect }) => {
    setClient($axios)

    $axios.onError((error) => {
        const status = parseInt(error?.response?.status, 10)
        const msg = error?.response?.data?.message
        const errorCode = error?.response?.data?.error
        const requestUrl = error?.config?.url || ''

        const isMemberSessionApi =
            requestUrl.includes('member/session') ||
            requestUrl.includes('/member/session')

        if (isMemberSessionApi && errorCode === 'INVALID_SESSION') {
            return Promise.reject(error)
        }
        // 세션 만료 또는 인증 실패 처리
        if (errorCode === 'INVALID_SESSION' || status === 401) {
            try {
                $method.logout()
            } catch (e) {}

            try {
                store.dispatch('modal/SHOW_ALERT', {
                    content: msg || '로그인이 필요합니다.',
                })
            } catch (e) {}

            redirect('/Login')
            return Promise.reject(error)
        }
        // 권한 없음 처리
        if (errorCode === 'PERMISSION_DENIED' || status === 403) {
            try {
                store.dispatch('modal/SHOW_ALERT', {
                    content: msg || '접근 권한이 없습니다.',
                })
            } catch (e) {}

            redirect('/')
            return Promise.reject(error)
        }

        return Promise.reject(error)
    })
}